// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1VYRI","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2mjYt","obliqueLine":"membershipbadge_obliqueLine__2e5LT"};